<template>
  <el-form
    :inline="true"
    :model="ruleForm"
    :rules="rules"
    ref="ruleForm"
    label-width="100px"
    class="demo-ruleForm"
  >
    <el-card class="box-card">
      <div slot="header" style="height:40px;line-height: 40px;">
        <span>{{$t('addApartmentFSS.apartmentInfo')}}</span>
        <el-form-item style="float: right; padding: 3px 0">
          <el-button type="primary" @click="saveApartment" icon="el-icon-plus">{{$t('addApartmentFSS.saveApartment')}}</el-button>
        </el-form-item>
      </div>
      <el-form-item
        label-position="labelPosition"
        label-width="120px"
        :label="$t('addApartmentFSS.apartmentName')"
        prop="apartmentName"
      >
        <el-input v-model="ruleForm.apartmentName" :placeholder="$t('addApartmentFSS.apartmentName')"></el-input>
      </el-form-item>

      <el-form-item label-position="labelPosition" label-width="80px" :label="$t('addApartmentFSS.area')" prop="province">
        <el-input style="width:180px" v-show="language=='en'" v-model="ruleForm.province" :placeholder="$t('addApartmentFSS.province')"></el-input>
        <el-select
          v-show="language=='zh'"
          v-model="ruleForm.province"
          :disabled="ruleForm.isDisabled"
          @change="getProvinceValue"
          style="width:180px"
          :placeholder="$t('addApartmentFSS.province')"
          filterable
        >
          <el-option
            v-for="item in this.$store.state.provinceList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-position="labelPosition" prop="city">
        <el-input style="width:180px" v-show="language=='en'" v-model="ruleForm.city" :placeholder="$t('addApartmentFSS.city')"></el-input>
        <el-select
          v-show="language=='zh'"
          v-model="ruleForm.city"
          :disabled="ruleForm.isDisabled"
          @change="getCityValue"
          style="width:180px"
          :placeholder="$t('addApartmentFSS.city')"
          filterable
        >
          <el-option
            v-for="item in this.$store.state.cityList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label-position="labelPosition" prop="area">
        <el-input style="width:180px" v-show="language=='en'" v-model="ruleForm.area" :placeholder="$t('addApartmentFSS.area-county')"></el-input>
        <el-select
          v-show="language=='zh'"
          v-model="ruleForm.area"
          :disabled="ruleForm.isDisabled"
          :placeholder="$t('addApartmentFSS.area-county')"
          style="width:180px"
          prop="area"
          filterable
        >
          <el-option
            v-for="item in this.$store.state.areaList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        label-position="labelPosition"
        label-width="120px"
        :label="$t('addApartmentFSS.address')"
        prop="apartmentAddress"
      >
        <el-input
          v-model="ruleForm.apartmentAddress"
          :disabled="ruleForm.isDisabled"
          :placeholder="$t('addApartmentFSS.apartmentAddress')"
          style="width:550px"
        ></el-input>
      </el-form-item>
    </el-card>

    <el-card class="box-card" style="margin-top:15px">
      <div slot="header" style="height:40px;line-height: 40px;">
        <span>{{$t('addApartmentFSS.roomInfo')}}</span>
        <el-form-item style="float: right; padding: 3px 0">
          <el-button-group>
            <!-- <el-button type="primary" icon="el-icon-plus">新增楼栋</el-button> -->
            <el-button type="primary" @click="createRooms" icon="el-icon-plus">{{$t('addApartmentFSS.createRoom')}}</el-button>
            <el-button type="danger" @click="removeRooms" icon="el-icon-delete">{{$t('addApartmentFSS.clearRoom')}}</el-button>
          </el-button-group>
        </el-form-item>

        <el-form-item
          :label="$t('addApartmentFSS.roomCount')"
          style="float: right; padding: 3px 0;"
          prop="roomNum"
          label-width="120px"
          :rules="[{ type: 'number', message:this.$t('addApartmentFSS.roomFormatError')}]"
        >
          <el-input
            type="text"
            v-model.number="ruleForm.roomNum"
            :placeholder="$t('addApartmentFSS.roomCount-input')"
            style="width:150px"
            maxlength="3"
            show-word-limit
          ></el-input>
        </el-form-item>
      </div>
      <div v-for="o in roomData" :key="o.roomId" class="text item">
        <el-col :span="6" style="height:60px">
          <el-input :placeholder="$t('addApartmentFSS.roomName-input')" v-model="o.roomName" style="width:80%">
            <el-button slot="append" style="color:red" icon="el-icon-delete" @click="removeRoom(o)"></el-button>
          </el-input>
        </el-col>
      </div>
    </el-card>
  </el-form>
</template> 
<script>
export default {
  name: "addApartmentFSS",
  props: ["idata","tabIndex"],
  data() {
    return {
      language:localStorage.getItem("language"),
      labelPosition: "right",
      roomData: [],
      ruleForm: {
        apartmentName: "",
        province: "",
        city: "",
        area: "",
        apartmentAddress: "",
        isDisabled: false, //公寓信息是否编辑状态
        roomNum: ""
      },
      rules: {
        apartmentName: [
          { required: true, message: this.$t('addApartmentFSS.apartmentName-input'), trigger: "blur" }
        ],
        apartmentAddress: [
          { required: true, message: this.$t('addApartmentFSS.apartmentAddress-input'), trigger: "blur" }
        ],
        // province: [{ required: true, message: this.$t('addApartmentFSS.province-input'), trigger: "blur" }],
        // city: [{ required: true, message:this.$t('addApartmentFSS.city-input'), trigger: "blur" }],
        // area: [{ required: true, message: this.$t('addApartmentFSS.area-input'), trigger: "blur" }]
      }
    };
  },
  created() {
    this.$store.commit("province", {}); //加载省份
    this.$store.commit("roomType", {}); //加载省份
  },
  methods: {
    saveApartment(event) {
       if(this.roomData==null || this.roomData==""){
        this.$message({
          message:this.$t('update.createRoomsInfo'),
          type: "warning"
        });
        return false;
      }
      this.$refs.ruleForm.validate(valid => {
      if (valid) {
        var formData = new FormData();  
        if(this.ruleForm.province!=""&&this.ruleForm.province!=null){
          if(this.language=='zh'){
             var provinceObj = this.$store.state.provinceList.find(item => {
              //model就是上面的数据源
               return item.code === this.ruleForm.province; //筛选出匹配数据
             });
            formData.append("province",provinceObj.name);
          }else{
            formData.append("province",this.ruleForm.province);
          }
       
        }
          
        if(this.ruleForm.city!=""&&this.ruleForm.city!=null){
         if(this.language=='zh'){  
           var cityObj = this.$store.state.cityList.find(item => {
             //model就是上面的数据源
             return item.code === this.ruleForm.city; //筛选出匹配数据
           });
           formData.append("city",cityObj.name);
         }else{
           formData.append("city",this.ruleForm.city);
         }  
        }

        if( this.ruleForm.area!=""&& this.ruleForm.area!=null){  
         if(this.language=='zh'){ 
           var areaObj = this.$store.state.areaList.find(item => {
            //model就是上面的数据源
            return item.code === this.ruleForm.area; //筛选出匹配数据
           });
           formData.append("area",areaObj.name);
         }else{
           formData.append("area",this.ruleForm.area);
         } 
        }  
          //整理房间数组
          var buildingList =[];
          var buldingObj = {};
          var floorList = [];
          var floorObj = {};
          floorObj.floorName = "1f";
          floorObj.roomList = this.roomData;
          floorList.push(floorObj);
          buldingObj.buildingName = "1b";
          buldingObj.floorList = floorList;
          buildingList.push(buldingObj);
          formData.append("apartmentNo",1);
          formData.append("apartmentName",this.ruleForm.apartmentName);
          formData.append("apartmentAddress",this.ruleForm.apartmentAddress);
          formData.append("apartmentType",0);
          formData.append("roomList",window.JSON.stringify(buildingList));
          this.$server
            .exam("/customer/apartment/addApartment", formData)
            .then(data => {
              if (data.code == 200) {
                  this.$message({
                  message: data.message,
                  type: "success"
                  });
                  this.$main.removeTab(this.tabIndex);
                  // 跳转公寓列表
                  var data={};
                  data.tabName=this.$t('apartmentList.apartmentList');
                  data.id="1"
                  data.comp="apartmentList";
                  this.$main.addApartmentTab(data);
              } else {
                this.$message({
                  message: data.message,
                  type: "warning"
                });
              }
            });
        } else {
          console.log("error submit!");
          return false;
        }
      });
    },
    createRooms(event) {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.roomData = [];
          var roomNum = this.ruleForm.roomNum;
          for (var i = 1; i < roomNum + 1; i++) {
            var roomId = (Array(3).join(0) + i).slice(-3);
            var obj = {};
            obj.roomId = roomId;
            obj.roomName = this.$util.prefixInteger(roomId,4)+this.$t('addApartmentFSS.room');
            obj.roomTypeId = this.$store.state.roomTypeList[0].roomTypeId;
            this.roomData.push(obj);
          }
        } else {
          console.log("error submit!");
          return false;
        }
      });
    },
    removeRooms() {
      this.roomData = [];
    },
    removeRoom(obj){
      this.roomData = this.roomData.filter((item) => {
        return item.roomId !=obj.roomId;
      });
    },
    getCityValue(val) {
      this.$store.commit("area", { cityCode: val }); //加载区（县）
      this.ruleForm.area = "";
    },
    getProvinceValue(val) {
      this.$store.commit("city", { provinceCode: val }); //加载城市
      this.ruleForm.city = "";
      this.ruleForm.area = "";
    }
  }
};
</script>  


// WEBPACK FOOTER //
// src/components/apartment/addApartmentFSS.vue